var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner"}),(_vm.message)?_c('div',[_vm._v(_vm._s(_vm.message))]):_c('div',{staticClass:"is-sr-only"},[_vm._v("Loading...")])])}
var staticRenderFns = []

export { render, staticRenderFns }